import { withFinancialMetricsAccess } from "@crm-src/components/page-permission-guard"
import { useState, useEffect } from "react"
import { Box } from "@mui/material"
import { usePermissions } from "@crm-src/hooks/usePermissions"
import { financialApi } from "@crm-src/lib/api"
import { useToast } from "@crm-src/hooks/use-toast"
import { useNavigate, useSearchParams } from "react-router-dom";
import { LeaderboardData, PeriodType, SortByType } from "@crm-src/types/financial-metrics"
import { SalespeoplePerformanceList } from "@crm-src/components/financial-metrics/salespeople-performance-list"

function SalespeoplePerformancePage() {
  const [searchParams] = useSearchParams()
  const periodParam = searchParams.get('period') as PeriodType || '1M'
  
  const [period] = useState<PeriodType>(periodParam)
  const [sortBy, setSortBy] = useState<SortByType>('revenue')
  const [leaderboardData, setLeaderboardData] = useState<LeaderboardData | null>(null)
  const [isLoadingLeaderboard, setIsLoadingLeaderboard] = useState(false)
  
  const { canAccessAdmin } = usePermissions()
  const { toast } = useToast()
  const navigate = useNavigate()
  const isAdmin = canAccessAdmin()

  // Load leaderboard
  useEffect(() => {
    if (isAdmin) {
      loadLeaderboard()
    }
  }, [period, sortBy, isAdmin])

  const loadLeaderboard = async () => {
    try {
      setIsLoadingLeaderboard(true)
      const response = await financialApi.getLeaderboard({ period, sort_by: sortBy })
      setLeaderboardData(response.data)
    } catch (error: any) {
      console.error('Error loading leaderboard:', error)
      toast({
        title: "Error",
        description: error.response?.data?.error || "Failed to load salespeople performance",
        variant: "destructive",
      })
    } finally {
      setIsLoadingLeaderboard(false)
    }
  }

  const handleSalespersonClick = (userId: number) => {
    navigate(`/crm/financial-metrics/salespeople/${userId}?period=${period}`)
  }

  const handleSortChange = (newSortBy: SortByType) => {
    setSortBy(newSortBy)
  }

  if (!isAdmin) {
    return null
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 3 }}>
      {leaderboardData && (
        <SalespeoplePerformanceList
          data={leaderboardData.leaderboard}
          sortBy={sortBy}
          onSortChange={handleSortChange}
          onSelectSalesperson={handleSalespersonClick}
          isLoading={isLoadingLeaderboard}
        />
      )}
    </Box>
  )
}

export default withFinancialMetricsAccess(SalespeoplePerformancePage)



